import { Component, OnInit } from '@angular/core';
import { ClientService } from 'src/app/services/client.service';
import { DropboxService } from 'src/app/services/dropbox.service';
import { ProcoreService } from 'src/app/services/procore.service';
import { ContextService } from '../../services/context.service';

@Component({
	selector: 'app-core',
	templateUrl: './core.component.html',
	styleUrls: ['./core.component.css']
})
export class CoreComponent implements OnInit {
	// Loading Vars
	loadingClient = false;
	loadingDropboxAccount = false;
	loadingProjects = false;

	// Project Vars
	projects = [];
	selectedProject;
	selectedProjectFilterStatus;

	// Configure Vars
	showConfigurations = false;

	// Sync Vars
	dropboxAccount;

	constructor(
		private clientService: ClientService,
		public contextService: ContextService,
		private dropboxService: DropboxService,
		private procoreService: ProcoreService
	) { }

	ngOnInit() {
		this.retrieveDropboxAccount();
		this.retrieveProcoreProjects();
		this.retrieveClient();
	}

	retrieveClient() {
		this.loadingClient = true;
		this.clientService.getClient(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (response) => {
					if (response) {
						this.contextService.client = response;
					} else {
						this.clientService.createClient(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
							.subscribe({
								next: (response) => {
									this.contextService.client = response;

									this.loadingClient = false;
								},
								error: () => {
									this.loadingClient = false;
								}
							});
					}

					this.loadingClient = false;
				},
				error: () => {
					this.loadingClient = false;
				}
			});
	}

	retrieveProcoreProjects() {
		this.loadingProjects = true;
		this.procoreService.getProjects(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (response) => {
					for (let project of response) {
						this.processProcoreProject(project);
					}

					this.loadingProjects = false;
				},
				error: () => {
					this.loadingProjects = false;
				}
			});
	}

	processProcoreProject(project) {
		if (this.contextService.procoreContextObject.context.project_id == project.id) {
			this.selectProcoreProject(project);
		}
		this.projects.push(project);
	}

	selectProcoreProject(project) {
		this.selectedProject = project;
	}

	retrieveDropboxAccount() {
		this.loadingDropboxAccount = true;
		this.dropboxService.getUserAccount(this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (response) => {
					this.contextService.dropboxAccount = response;
					this.loadingDropboxAccount = false;
				},
				error: () => {
					// No user exists, do nothing.
					this.loadingDropboxAccount = false;
				}
			});
	}

	/// 

	showConfigure() {
		this.showConfigurations = true;
	}

	hideConfigure() {
		this.showConfigurations = false;
	}
}
